import Flickity from "flickity";

require("flickity-sync");
require("flickity-as-nav-for");

class InsightCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.carouselElemNav = self.elem.querySelector('[data-carousel-nav]');
        self.carouselItems = self.elem.querySelectorAll('[data-carousel-item]');
    }

    init() {
        let self = this;

        self.getCarousel();
    }

    getCarousel() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            autoPlay: false,
            contain: true,
            draggable: false,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            fade: true,
            setGallerySize: true
        });

        // On change of carousel slide
        flkty.on('select', index => {
            // Update selected thumbnail
            [...self.carouselItems].map(item => {
                if (item.getAttribute('data-carousel-item-count') == index) {
                    item.classList.add('is-selected');
                } else {
                    item.classList.remove('is-selected');
                }
            });
        });

        var previousButton = self.elem.querySelector('[data-carousel-button-previous]');
        var nextButton = self.elem.querySelector('[data-carousel-button-next]');

        previousButton.addEventListener('click', function() {
            flkty.previous();
        });

        nextButton.addEventListener('click', function() {
            flkty.next();
        });

        const galleryNav = self.elem.querySelector('[data-carousel-nav]');
        const galleryNavItems = galleryNav.querySelectorAll('[data-carousel-item]');

        galleryNav.addEventListener('select', function() {
            const selectedNavItem = galleryNav.querySelector('.is-selected');

            if (selectedNavItem) {
                selectedNavItem.classList.remove('is-selected');
            }

            galleryNavItems[flkty.selectedIndex].classList.add('is-selected');
        });

        galleryNavItems.forEach((navItem, index) => {
            navItem.addEventListener('click', function() {
                const clickedIndex = index;

                flkty.select(clickedIndex);
            });
        });

        window.onresize = function(event) {
            flkty.resize();
            self.elem.querySelector('.flickity-viewport').style.height = 'inherit';
        };
    }
}

export default InsightCarousel;
